import type { PartnershipStatus } from "Order/Modules/MorningCheck/Api/Query/usePartnershipRecordsQuery";
import CheckCircle from "@mui/icons-material/CheckCircle";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import {
	Card,
	CardContent,
	CardHeader,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
} from "@mui/material";
import type { FC } from "react";

type MorningCheckStatusCardProps = {
	status: PartnershipStatus;
};

const STATUS_ITEMS = [
	{ key: "connected" as const, label: "Customer Connected" },
	{ key: "started" as const, label: "Job Started" },
	{ key: "finished" as const, label: "Job Completed" },
	{ key: "examined" as const, label: "Examination Submitted" },
];

export const MorningCheckStatusCard: FC<MorningCheckStatusCardProps> = ({
	status,
}) => {
	const completedCount = STATUS_ITEMS.filter((item) => status[item.key]).length;
	const totalSteps = STATUS_ITEMS.length;

	return (
		<Card variant="outlined">
			<CardHeader
				title="Partner Progress"
				subheader={
					<Typography variant="body2" color="text.secondary">
						{completedCount}/{totalSteps} steps completed
					</Typography>
				}
				titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
				sx={{ pb: 0 }}
			/>
			<CardContent sx={{ pt: 1 }}>
				<List dense disablePadding>
					{STATUS_ITEMS.map((item) => {
						const done = status[item.key];
						return (
							<ListItem key={item.key} disableGutters sx={{ py: 0.25 }}>
								<ListItemIcon sx={{ minWidth: 32 }}>
									{done ? (
										<CheckCircle color="success" fontSize="small" />
									) : (
										<RadioButtonUnchecked color="disabled" fontSize="small" />
									)}
								</ListItemIcon>
								<ListItemText
									primary={item.label}
									primaryTypographyProps={{
										variant: "body2",
										color: done ? "text.primary" : "text.secondary",
										sx: done
											? { textDecoration: "line-through", opacity: 0.7 }
											: undefined,
									}}
								/>
							</ListItem>
						);
					})}
				</List>
			</CardContent>
		</Card>
	);
};
